import { Component, NgZone, OnDestroy, Input } from "@angular/core";
import { Subscription } from "rxjs";
import { ImpersonationService } from "../../../../auth/apigee/impersonation.service";
import { LoggerService } from "../../../../common/logging/logger.service";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { DiscontinuousPermanentWorkersService, DiscontinuousPermanentWorkersServiceData } from "../../services/discontinuousPermanentWorkersKpi/discontinuousPermanentWorkers.service";
import { DiscontinuousPermanentWorkersDetailService, DiscontinuousPermanentWorkersDetailServiceData } from "../../services/discontinuousPermanentWorkersKpi/discontinuousPermanentWorkersDetail.service";
import { DiscontinuousPermanentWorkersKpiCfg, DiscontinuousPermanentWorkersKpiCfgService } from "../../services/discontinuousPermanentWorkersKpi/discontinuousPermanentWorkersKpiCfg.service";
import { ModalDialogComponent } from "../../../../common/modal/modalDialog.component";
import { ColumnDefinition, EmailColumnDefinition, LinkColumnData, LinkColumnDefinition, NumberColumnDefinition, PhoneNumberColumnDefinition, TextColumnDefinition } from "../../../../dashboardCommon/components/cardDetails/datatable.component";
import { DualSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";
import "../../../../util/array";

export class DiscontinuousPermanentWorkersData {
    public consultant: number;
    public office: number;

    constructor(consultant: number, office: number) {
        this.consultant = consultant;
        this.office = office;
    }
}

export class DiscontinuousPermanentWorkersDetailData {
    public columnDefinitions: ColumnDefinition[];
    public tabledata: any[][];

    constructor(columnDefinitions: ColumnDefinition[], tabledata: any[][]) {
        this.columnDefinitions = columnDefinitions;
        this.tabledata = tabledata;
    }
}

@Component({
    selector: 'discontinuous-permanent-workers-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class DiscontinuousPermanentWorkersKpiServiceHostComponent extends DualSummaryDetailKpiServiceHost<DiscontinuousPermanentWorkersService, DiscontinuousPermanentWorkersServiceData, DiscontinuousPermanentWorkersData, DiscontinuousPermanentWorkersDetailService, DiscontinuousPermanentWorkersDetailServiceData, DiscontinuousPermanentWorkersDetailData>
    implements OnDestroy {
    public getClassName() { return ""; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    @Input() public detailDialog: ModalDialogComponent;
    @Input() public messageDialog: ModalDialogComponent;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
        summaryService: DiscontinuousPermanentWorkersService, detailService: DiscontinuousPermanentWorkersDetailService, private serviceCfg: DiscontinuousPermanentWorkersKpiCfgService) {
        super(zone, logger, summaryService, detailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: DiscontinuousPermanentWorkersServiceData): DiscontinuousPermanentWorkersData {
        return new DiscontinuousPermanentWorkersData(data.consultant, data.office);
    }

    protected getDefaultSummaryData(): DiscontinuousPermanentWorkersData {
        let data = new DiscontinuousPermanentWorkersData(0, 0);
        return data;
    }

    protected extractUpdateTime(data: DiscontinuousPermanentWorkersServiceData): Date {
        return data.updateTimestamp;
    }

    protected processDetailData(data: DiscontinuousPermanentWorkersDetailServiceData, args: any): DiscontinuousPermanentWorkersDetailData {
        let columnDefinitions = this.getColumnsDefault();

        let cfg: DiscontinuousPermanentWorkersKpiCfg = this.serviceCfg.getCfg();

        let tabledata = [];
        (data.discontinuous || [])
            .forEach(w =>
                tabledata.push([
                    new LinkColumnData(w.workerName, cfg.urlTalent + 'candidates/' + w.workerId),
                    w.workerPhone,
                    w.workerEmail,
                    w.daysStandBy,
                    w.nameLastJob,
                    w.jobType
                ]));

        return new DiscontinuousPermanentWorkersDetailData(columnDefinitions, tabledata);
    }

    protected getDefaultDetailData(): DiscontinuousPermanentWorkersDetailData {
        let columnDefinitions = this.getColumnsDefault();

        return new DiscontinuousPermanentWorkersDetailData(columnDefinitions, []);
    }

    protected performDetailAction(): void {
        if (this.detailDialog) this.detailDialog.open();
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }

    public mergeFilter(filter: any) {
        let detailProcessingArgs = this.detailProcessingArgs || {};
        detailProcessingArgs.filter = detailProcessingArgs.filter || {};
        detailProcessingArgs.filter = { ...detailProcessingArgs.filter, ...filter };
        this.detailProcessingArgs = detailProcessingArgs;
    }

    /**
     * Método que define las columnas, sus etiquetas y medidas
     * @returns Arreglo de columnas por defecto para la grilla
     */
    public getColumnsDefault(): any {
        let columnDefinitions = [
            new TextColumnDefinition("Trabajador", null, true),
            new PhoneNumberColumnDefinition("Teléfono"),
            new EmailColumnDefinition("Email"),
            new NumberColumnDefinition("Días en\nstand by", null, false, 80),
            new TextColumnDefinition("Perfil solicitado", null, false),
            new TextColumnDefinition("Job type", null, false),
        ];

        return columnDefinitions;
    }
}
